import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EnterpriseCardProfile } from '../card/EnterpriseCardProfile';
import { EntitiesCardFooter } from '../../components/entities-card/EntitiesCardFooter';
import { EntitiesCardBody } from '../../components/entities-card/EntitiesCardBody';
import { EnterpriseCardType } from '../card/enterpriseCard.types';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import { useUser } from '../../user/useUser';

type Props = {
  enterprise: EnterpriseCardType;
  source: string;
};

export const EnterpriseCard: FC<Props> = ({ enterprise, source }) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const handleClick = (src: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source: src });
    }
  };

  return (
    <>
      <EntitiesCardBody>
        <EnterpriseCardProfile
          enterprise={enterprise}
          href={
            accessPremium
              ? `${enterprise.url}?source=${source}-header`
              : undefined
          }
          onClick={handleClick(`${source}-header`)}
        />
      </EntitiesCardBody>
      <EntitiesCardFooter
        href={
          accessPremium
            ? `${enterprise.url}?source=${source}-footer`
            : undefined
        }
        onClick={handleClick(`${source}-footer`)}
      >
        <FormattedMessage id="app.entities.popover.footer" />
      </EntitiesCardFooter>
    </>
  );
};
